import React from 'react';
import styles from './style.module.css';
import ContactForm from '../../components/forms/contact';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Thanks for filling out Libro’s Mortgage Calculator!</p>
        <h1 className={styles.mainTitle}>Connect with a Libro Coach to get started</h1>
        <p className={styles.text}>Contact a Libro Coach today to find out how much you can borrow. Complete the form and your Libro Coach will have your mortgage calculations ready when they meet with you!</p>
        <ContactForm/>
    </div>
);
